import { SidebarMenuButton, SidebarMenuItem } from '@predoc/cow';
import { NavLink, useLocation } from 'react-router';
import { Permission, useHasPermission } from '@/utils/roles';

export const SidebarNavItem = ({
  title,
  url,
  icon: Icon,
  requiredPermissions = [],
  alsoActiveOn = [],
  permissionsEnabled = true,
}: {
  title: string;
  url: string;
  icon: React.ElementType;
  requiredPermissions?: Permission[];
  alsoActiveOn?: string[];
  permissionsEnabled?: boolean;
}) => {
  const { hasPermission } = useHasPermission(requiredPermissions ?? [], true, {
    enabled: permissionsEnabled,
  });
  const location = useLocation();

  // Don't render if user lacks required permissions
  if (requiredPermissions?.length > 0 && !hasPermission) {
    return null;
  }

  const isAlsoActive = alsoActiveOn.some(
    (path) =>
      location.pathname === path || location.pathname.startsWith(path + '/'),
  );

  return (
    <SidebarMenuItem key={title}>
      <NavLink to={url}>
        {({ isActive }) => (
          <SidebarMenuButton
            size="lg"
            data-active={isActive || isAlsoActive}
            className="w-full cursor-pointer" // TODO: Remove this once we have those updated in the cow package
          >
            <Icon strokeWidth={1.3} className="h-5 w-5" />
            <span>{title}</span>
          </SidebarMenuButton>
        )}
      </NavLink>
    </SidebarMenuItem>
  );
};
